import { NgTemplateOutlet } from '@angular/common';
import { Component, output, input } from '@angular/core';

import type { Currency, PaymentInterval } from '@core/billing-types';
import { BillingPlanTier } from '@core/billing-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, DividerComponent, PlanButtonComponent } from '@core/user-interface-legacy';

import { JobSlotsLimitMessageComponent } from '../../../job-slots-limit-message/job-slots-limit-message.component';
import { PlanPickerProductCtaLabelPipe } from '../../plan-picker-product-cta-label.pipe';
import { ProductStatus } from '../../plan-picker.types';
import type { Product, Products } from '../plan-picker-2024.types';
import { ViewMode } from '../plan-picker-2024.types';
import { PlanPicker2024ProductPriceComponent } from '../plan-picker-product-price/plan-picker-2024-product-price.component';

@Component({
  selector: 'rt-plan-picker-2024-products',
  templateUrl: './plan-picker-2024-products.component.html',
  styleUrls: ['./plan-picker-2024-products.component.less'],
  imports: [
    PlanPicker2024ProductPriceComponent,
    PlanButtonComponent,
    BadgeComponent,
    NgTemplateOutlet,
    JobSlotsLimitMessageComponent,
    DividerComponent,
    TranslatePipe,
    PlanPickerProductCtaLabelPipe,
  ],
})
export class PlanPicker2024ProductsComponent {
  protected readonly ProductStatus = ProductStatus;

  public readonly viewMode = input<ViewMode>(ViewMode.Default);
  public readonly interval = input<PaymentInterval>(undefined!);
  public readonly currency = input<Currency>(undefined!);
  public readonly products = input<Products>(undefined!);
  public readonly showTrialBadge = input(false);
  public readonly showSlotsLimitMessage = input(false);
  public readonly startPlanSlotsLimit = input<number>(undefined!);

  public chooseProduct = output<Product>();
  public cancelSubscription = output<void>();

  public BillingPlanTier = BillingPlanTier;
  public ViewMode = ViewMode;

  public isButtonDisabled(status: ProductStatus) {
    return status === ProductStatus.Owned || status === ProductStatus.ManualServiceOwned;
  }

  public showCancelSubscription(status: ProductStatus) {
    return status === ProductStatus.TierOwned || status === ProductStatus.Owned;
  }
}
